import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Planning\CopyMaterialResourceToEventsDossierController::__invoke
* @see app/Http/Controllers/Planning/CopyMaterialResourceToEventsDossierController.php
* @route '/api/planning/{event}/copy-material-resource-dossier/{material_resource}'
*/
const CopyMaterialResourceToEventsDossierController = (args: { event: string | number | { id: string | number }, material_resource: string | number | { id: string | number } } | [event: string | number | { id: string | number }, material_resource: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CopyMaterialResourceToEventsDossierController.url(args, options),
    method: 'post',
})

CopyMaterialResourceToEventsDossierController.definition = {
    methods: ["post"],
    url: '/api/planning/{event}/copy-material-resource-dossier/{material_resource}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Planning\CopyMaterialResourceToEventsDossierController::__invoke
* @see app/Http/Controllers/Planning/CopyMaterialResourceToEventsDossierController.php
* @route '/api/planning/{event}/copy-material-resource-dossier/{material_resource}'
*/
CopyMaterialResourceToEventsDossierController.url = (args: { event: string | number | { id: string | number }, material_resource: string | number | { id: string | number } } | [event: string | number | { id: string | number }, material_resource: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            event: args[0],
            material_resource: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        event: typeof args.event === 'object'
        ? args.event.id
        : args.event,
        material_resource: typeof args.material_resource === 'object'
        ? args.material_resource.id
        : args.material_resource,
    }

    return CopyMaterialResourceToEventsDossierController.definition.url
            .replace('{event}', parsedArgs.event.toString())
            .replace('{material_resource}', parsedArgs.material_resource.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Planning\CopyMaterialResourceToEventsDossierController::__invoke
* @see app/Http/Controllers/Planning/CopyMaterialResourceToEventsDossierController.php
* @route '/api/planning/{event}/copy-material-resource-dossier/{material_resource}'
*/
CopyMaterialResourceToEventsDossierController.post = (args: { event: string | number | { id: string | number }, material_resource: string | number | { id: string | number } } | [event: string | number | { id: string | number }, material_resource: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CopyMaterialResourceToEventsDossierController.url(args, options),
    method: 'post',
})

export default CopyMaterialResourceToEventsDossierController